import localizationService from "../../services/localization-service.js";
import { useSelector } from "react-redux";

const SmsReminderModal = ({ isOpen, onClose }) => {
  const selectedlang = useSelector((state) => state.account.lang);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div
          className="px-6 py-4 border-b border-gray-200"
          style={{ position: "relative" }}
        >
          <h3 className="text-lg font-medium text-gray-900">
            {localizationService.getLocalizationValue(
              "textMessageReminderTitle",
              selectedlang,
            )}
          </h3>
        </div>
        <div className="px-6 py-4">
          <p className="text-sm text-gray-500 mb-3">
            {localizationService.getLocalizationValue(
              "textMessageReminderPartOne",
              selectedlang,
            )}
          </p>
          <p className="text-sm text-gray-500">
            {localizationService.getLocalizationValue(
              "textMessageReminderPartTwo",
              selectedlang,
            )}
          </p>
        </div>
        <div className="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-center space-x-3">
          <button
            onClick={() => onClose("/textMessages")}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#9aa82d] hover:bg-[#7d8a1f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          >
            {localizationService.getLocalizationValue("yes", selectedlang)}
          </button>
          <button
            onClick={() => onClose("/")}
            className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-[#ffffff] hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200"
          >
            {localizationService.getLocalizationValue("later", selectedlang)}
          </button>
          <button
            onClick={() => onClose("/", true)}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#C44D4D] hover:bg-[#9c3d3d] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#9c3d3d]"
          >
            {localizationService.getLocalizationValue("noThanks", selectedlang)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SmsReminderModal;
